import React from 'react';

import './_calls.scss'
import {
  Breadcrumb,
  BreadcrumbItem,
  Column,
  FormLabel,
  Grid,
  Tile, Toggle,
  Toggletip, ToggletipButton, ToggletipContent
} from "@carbon/react";
import {Information} from '@carbon/react/icons';
import {Link} from "react-router-dom";
import CallsTable from "../../components/CallsTable";
import PropTypes from "prop-types";

const Calls = (props) => {
  const enabled = props.callsEnabled
  const onToggle = props.toggleCallsStatus
  return (
    <Grid fullWidth className="calls-page">
      <Column lg={16} md={8} sm={4}>
        <Grid className="page-banner">
          <Column lg={16} md={4} sm={4}>
            <Breadcrumb noTrailingSlash aria-label="Page navigation">
              <BreadcrumbItem>
                <Link to='/'>Home</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                Centralino
              </BreadcrumbItem>
            </Breadcrumb>
          </Column>
          <Column lg={16} md={4} sm={4}>
            <h1 className="page-heading">
              Centralino
            </h1>
          </Column>
        </Grid>
        <Grid>
          <Column lg={16} md={8} sm={4} className="calls-page__r1">
            <Tile>
              <div className="form-wrapper" style={{marginBottom: '1rem'}}>
                <FormLabel>Attivazione centralino</FormLabel>
                <Toggletip>
                  <ToggletipButton label="Mostra informazioni">
                    <Information/>
                  </ToggletipButton>
                  <ToggletipContent>
                    Se il centralino viene disattivato, l'inoltro di qualunque messaggio vocale verrà interrotto.
                    Questo significa che qualunque nuovo allarme, configurato nel centralino, non verrà processato
                    dal momento della disattivazione.
                    Nota bene: i messaggi vocali che nel momento della disattivazione erano in fase di processo,
                    potrebbero comunque essere inviati.
                  </ToggletipContent>
                </Toggletip>
              </div>
              <Toggle
                id="calls-enabled"
                labelA="Disattivo"
                labelB="Attivo"
                toggled={enabled}
                onToggle={onToggle}
              />
            </Tile>
          </Column>
        </Grid>
        <Grid>
          <Column lg={16} md={8} sm={4} className="calls-page__r1">
            <Tile>
              <CallsTable/>
            </Tile>
          </Column>
        </Grid>
      </Column>
    </Grid>
  )
}

Calls.propTypes = {
  callsEnabled: PropTypes.bool.isRequired,
  toggleCallsStatus: PropTypes.func.isRequired,
}

export default Calls